import { render, staticRenderFns } from "./ManagementSectorCard.vue?vue&type=template&id=0ee7c954&scoped=true&"
import script from "./ManagementSectorCard.vue?vue&type=script&lang=js&"
export * from "./ManagementSectorCard.vue?vue&type=script&lang=js&"
import style0 from "./ManagementSectorCard.vue?vue&type=style&index=0&id=0ee7c954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7c954",
  null
  
)

export default component.exports